/**
 * Single owner of the shortest-path highlight class (`path-highlight`, styled
 * for both nodes and edges in ./styles.ts). Every applier and remover — the
 * useCytoscapePathFinding hook exposed on CytoscapeGraphRef, the cockpit-store
 * highlight consumed by InvestigationCanvas, and the ring-menu Find Path tool
 * — goes through these helpers so the styling only has to change in one place.
 */

import type { Core } from 'cytoscape'
import { safeBatch } from './safe-batch'

export function clearPathHighlight(cy: Core) {
  cy.elements('.path-highlight').removeClass('path-highlight')
}

/**
 * Replace any existing path highlight with the given one and fit the camera
 * to it. Ids missing from the canvas are silently skipped — the highlight
 * only ever marks elements already rendered.
 */
export function applyPathHighlight(cy: Core, nodeIds: string[], edgeIds: string[]) {
  safeBatch(cy, () => {
    clearPathHighlight(cy)
    for (const id of [...nodeIds, ...edgeIds]) {
      cy.$id(id).addClass('path-highlight')
    }
  })

  const pathElements = cy.$('.path-highlight')
  if (pathElements.length > 0) {
    cy.animate({ fit: { eles: pathElements, padding: 50 }, duration: 500 })
  }
}
